import * as React from 'react';
import { useEffect, useState } from 'react';
import { Parallax } from 'react-scroll-parallax';
import AnimatedNumber from 'animated-number-react';
import Button from '../../../../components/Button';
import VisibilitySensor from 'react-visibility-sensor';

import MapGraphic from './assets/map.inline.svg';

import './style.scss';

import content from './content.json';

const ParticipantsCounterSection = () => {
  const { title, description, tickerSteps } = content;

  const [step, setStep] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (step < tickerSteps.length - 1 && visible) {
      setTimeout(() => {
        setStep(step + 1);
      }, 2000);
    }
  }, [visible, step, tickerSteps.length]);

  return (
      <section className="l-participants-counter-section">
        <Parallax className="background" y={[-30, 30]}>
          <div className="bg1" />
        </Parallax>

        <div className="container">
          <h2 className="section-title">{title}</h2>
          <p>{description}</p>
          
          <VisibilitySensor
            partialVisibility
            onChange={(isVisible) => (
              setVisible(isVisible)
            )}
          >
            <div className="map">
              <MapGraphic />
              <div className="text">
                <div className="fy">FY {tickerSteps[step].year}</div>
                <div className="number">
                  <AnimatedNumber
                    value={tickerSteps[step].value}
                    formatValue={value => Number(value.toFixed(0)).toLocaleString()}
                  />
                </div>
              </div>
            </div>
          </VisibilitySensor>


          <Button
            color="secondary"
            label="Replay"
            icon="replay"
            disabled={step < tickerSteps.length - 1}
            onClick={() => setStep(0)}
          />
        </div>
      </section>
  );
};

export default ParticipantsCounterSection;
